export interface Language {
    id: number;
    code: string;
    name: string;
    created_at: string;
    updated_at: string;
}
